import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { mockData } from '../data/mock';
import { ShareButtons } from './ShareButtons';

export const HowToJoin = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-11 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            ¿Cómo asociarse?
          </h2>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-4 md:gap-8 mb-8 sm:mb-10">
          {mockData.howToJoin.map((step, index) => (
            <div key={step.step} className="relative">
              <Card className="h-full border-2 hover:border-blue-500 hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6 sm:p-8">
                  <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mb-6 text-white text-2xl font-bold shadow-lg">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </CardContent>
              </Card>
              {index < mockData.howToJoin.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <ArrowRight className="w-8 h-8 text-blue-400" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Benefits Summary */}
        <div className="bg-white rounded-2xl p-6 sm:p-8 lg:p-12 shadow-xl border-2 border-blue-100">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 text-center">
            Al asociarte a la UIQ, obtenés acceso inmediato a:
          </h3>
          <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
            {[
              'Asesoramiento gratuito en todos nuestros servicios',
              'Servicios con descuentos exclusivos',
              'Red de contactos con más de 180 empresas industriales',
              'Representación ante organismos públicos',
              'Acceso a capacitaciones, visitas técnicas y eventos',
              'Gestión de trámites'
            ].map((benefit, index) => (
              <div key={index} className="flex items-start space-x-3">
                <CheckCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">{benefit}</span>
              </div>
            ))}
          </div>
          <div className="mt-8 pt-6 border-t border-blue-100 flex flex-col sm:flex-row items-center justify-center gap-3">
            <span className="text-gray-600 text-sm">¿Conocés una empresa que debería asociarse? Compartile el sitio:</span>
            <ShareButtons />
          </div>
        </div>
      </div>
    </section>
  );
};
